import restService from './rest.service'

async function alterarSenhaAsync(credentials) {
    const { data } = await restService.postAsync('email/alterarSenha', credentials);
    return data;
}

async function enderecoAtualAsync() {
    const { data } = await restService.postAsync('email/enderecoAtual');
    return data;
}

async function verificarAsync(email) {
    const { data } = await restService.postAsync('email/verificar', { email });
    return data;
}

export default { alterarSenhaAsync, enderecoAtualAsync, verificarAsync }